import { render } from "./DailyTasks.vue?vue&type=template&id=4cb4ad93"
import script from "./DailyTasks.vue?vue&type=script&lang=js"
export * from "./DailyTasks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__